export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const TARGET_HOST = 'video.jakesidsmith.com';
export const TARGET_DOMAIN = `https://${TARGET_HOST}`;
export const APP_NAME = "Jake's Video Party";
export const PARTY_TITLE = `Join me at ${APP_NAME}!`;
export const DEFAULT_USER_NAME = 'Some mysterious person';
export const DEFAULT_PARTY_NAME = 'Some mysterious party';
export const USER_ID_COOKIE = 'party-user-id';
